(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7395],{

/***/ 80167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ strategia_rozvoja_lektorov_a_timu; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/TeacherTeamDevelopmentStrategy/TeacherTeamDevelopmentStrategy.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeacherTeamDevelopmentStrategyelements__Wrapper",
  componentId: "sc-uoubl5-0"
})(["margin-top:", ";padding:0 ", ";@media (min-width:", "px){margin-top:", ";}.title{font-size:", ";font-weight:", ";color:", ";display:block;text-align:center;padding-bottom:", ";margin-top:", ";}.subTitle{font-weight:", ";display:block;text-align:center;padding-bottom:", ";}h1.sectionTitle{font-size:", ";font-weight:", ";display:block;padding:", " 0;}h2.sectionTitle{font-size:", ";font-weight:", ";display:block;padding:", " 0;}.underline{text-decoration:underline;}.marginLeft{margin-left:", ";}.section{a{color:", ";padding-right:", ";display:inline-flex;}}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(65), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(18), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(16), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(4));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/TeacherTeamDevelopmentStrategy/TeacherTeamDevelopmentStrategy.tsx




var TEACHER_TEAM_DEVELOPMENT_STRATEGY_ID = 'TeacherTeamDevelopmentStrategy';

var TeacherTeamDevelopmentStrategyTemplate = function TeacherTeamDevelopmentStrategyTemplate() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "title",
      id: "".concat(TEACHER_TEAM_DEVELOPMENT_STRATEGY_ID, "-sekcia"),
      children: "STRAT\xC9GIA ROZVOJA \u013DUDSK\xDDCH ZDROJOV"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "subTitle",
      children: "Poradca podnikate\u013Ea, s. r. o. \u2013 \xFAsek Vzdel\xE1vanie, platforma Profivzdel\xE1vanie.sk"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "\xDAVOD"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Rozvoj \u013Eudsk\xFDch zdrojov predstavuje komplexn\xFD, strategicky riaden\xFD a dlhodob\xFD proces, ktor\xFD v\xFDznamne ovplyv\u0148uje kvalitu poskytovan\xE9ho vzdel\xE1vania aj celkov\xFA profesionalitu vzdel\xE1vacej in\u0161tit\xFAcie. V prostred\xED dynamick\xFDch zmien, rast\xFAcich po\u017Eiadaviek trhu, digitaliz\xE1cie a potreby r\xFDchlej adapt\xE1cie odborn\xFDch inform\xE1ci\xED sa st\xE1va systematick\xFD rozvoj lektorov nevyhnutnou podmienkou \xFAspe\u0161n\xE9ho fungovania vzdel\xE1vacej platformy. Profivzdel\xE1vanie.sk ako s\xFA\u010Das\u0165 spolo\u010Dnosti Poradca podnikate\u013Ea vn\xEDma vzdel\xE1vanie nielen ako prenos inform\xE1ci\xED, ale aj ako odborn\xFD proces, ktor\xFD stoj\xED na spo\u013Eahliv\xFDch, kompetentn\xFDch a neust\xE1le sa rozv\xEDjaj\xFAcich lektoroch."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Z tohto d\xF4vodu je nevyhnutn\xE9 jasne a transparentne definova\u0165 pr\xEDstupy, princ\xEDpy a organiza\u010Dn\xE9 postupy, ktor\xE9 podporuj\xFA systematick\xFD profesijn\xFD rast lektorov. \xDAvodn\xE1 \u010Das\u0165 dokumentu vytv\xE1ra r\xE1mec pre pochopenie potreby pl\xE1novan\xE9ho rozvoja \u013Eudsk\xFDch zdrojov, zd\xF4raz\u0148uje v\xFDznam odbornej pripravenosti lektorsk\xE9ho t\xEDmu a poukazuje na to, \u017Ee kvalitne nastaven\xFD rozvoj lektorov m\xE1 priamy vplyv na odborn\xFA \xFArove\u0148, aktu\xE1lnos\u0165 a pridan\xFA hodnotu realizovan\xFDch \u0161kolen\xED."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Cie\u013Eom tohto dokumentu je preto poskytn\xFA\u0165 komplexn\xFD, systematicky usporiadan\xFD a odborne podlo\u017Een\xFD preh\u013Ead mechanizmov rozvoja \u013Eudsk\xFDch zdrojov \u2013 konkr\xE9tne lektorov \u2013 v r\xE1mci platformy Profivzdel\xE1vanie.sk. Dokument z\xE1rove\u0148 formuluje k\u013E\xFA\u010Dov\xE9 princ\xEDpy, kroky a opatrenia, ktor\xE9 spolo\u010Dnos\u0165 Poradca podnikate\u013Ea uplat\u0148uje pri podpore odborn\xE9ho, pedagogick\xE9ho aj osobnostn\xE9ho rastu svojich lektorov, pri\u010Dom zabezpe\u010Duje vysok\xFD \u0161tandard profesionality, kvality obsahu a odbornej d\xF4veryhodnosti."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "\xA0"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "1. CIELE STRAT\xC9GIE ROZVOJA \u013DUDSK\xDDCH ZDROJOV"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Rozvoj \u013Eudsk\xFDch zdrojov predstavuje systematicky riaden\xFD proces, ktor\xE9ho hlavn\xFDm z\xE1merom je neust\xE1le zvy\u0161ovanie odbornosti, kompeten\u010Dnej pripravenosti a profesion\xE1lnej kvality lektorsk\xE9ho t\xEDmu. V kontexte vzdel\xE1vacej organiz\xE1cie pln\xED t\xE1to strat\xE9gia v\xFDznamn\xFA \xFAlohu pri zabezpe\u010Dovan\xED udr\u017Eate\u013Enej kvality vzdel\xE1vac\xEDch slu\u017Eieb a z\xE1rove\u0148 vytv\xE1ra r\xE1mec pre dlhodob\xFD profesijn\xFD rast lektorov. Stanovenie jasn\xFDch cie\u013Eov umo\u017E\u0148uje organiz\xE1cii efekt\xEDvne pl\xE1nova\u0165 rozvojov\xE9 aktivity, identifikova\u0165 potreby lektorov, nastavova\u0165 merate\u013En\xE9 ukazovatele a zabezpe\u010Dova\u0165 transparentnos\u0165 v celom procese."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Ciele strat\xE9gie s\xFA definovan\xE9 na z\xE1klade potrieb organiz\xE1cie, aktu\xE1lnych \u0161tandardov v oblasti profesijn\xE9ho vzdel\xE1vania, dlhodob\xFDch prior\xEDt a sp\xE4tnej v\xE4zby zo strany lektorov aj \xFA\u010Dastn\xEDkov kurzov. Okrem toho reflektuj\xFA modern\xE9 pr\xEDstupy k riadeniu \u013Eudsk\xFDch zdrojov, ktor\xE9 zd\xF4raz\u0148uj\xFA d\xF4le\u017Eitos\u0165 celo\u017Eivotn\xE9ho vzdel\xE1vania, adaptabilitu na dynamicky sa meniace legislat\xEDvne prostredie a podporu odborn\xEDkov vo v\u0161etk\xFDch oblastiach ich profesijn\xE9ho p\xF4sobenia."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "1.1 Hlavn\xE9 ciele strat\xE9gie"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "1. Zabezpe\u010Di\u0165 vysok\xFA \xFArove\u0148 odborn\xFDch a pedagogick\xFDch kompetenci\xED lektorov:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "budovanie odbornosti v k\u013E\xFA\u010Dov\xFDch oblastiach (pr\xE1vo, \xFA\u010Dtovn\xEDctvo, personalistika, mana\u017Ement, BOZP a pod.),"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "rozvoj prezenta\u010Dn\xFDch, komunika\u010Dn\xFDch a didaktick\xFDch zru\u010Dnost\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zvy\u0161ovanie kvality vzdel\xE1vac\xEDch v\xFDstupov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "2. Podporova\u0165 kontinu\xE1lne vzdel\xE1vanie lektorov:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pravideln\xE9 vzdel\xE1vacie aktivity (kurzy, metodick\xE9 \u0161kolenia, webin\xE1re),"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dostupnos\u0165 modern\xFDch vzdel\xE1vac\xEDch met\xF3d,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "aktualiz\xE1cia odborn\xFDch poznatkov v s\xFAlade s legislat\xEDvnymi zmenami a trendmi."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "3. Vytvori\u0165 syst\xE9m pl\xE1novan\xE9ho profesijn\xE9ho rastu:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "identifik\xE1cia individu\xE1lnych rozvojov\xFDch potrieb,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "tvorba ro\u010Dn\xFDch pl\xE1nov vzdel\xE1vania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "systematick\xE1 podpora kari\xE9rneho postupu a odborn\xE9ho rastu."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4. Rozv\xEDja\u0165 kult\xFAru spolupr\xE1ce, zdie\u013Eania sk\xFAsenost\xED a\xA0dobropraxe:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podpora t\xEDmovej spolupr\xE1ce a komunik\xE1cie medzi lektormi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "mentoring a kou\u010Ding zo strany sk\xFAsen\xFDch odborn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "odborn\xE9 workshopy zameran\xE9 na zdie\u013Eanie osved\u010Den\xFDch postupov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "5. Poskytn\xFA\u0165 lektorom pr\xEDstup k odborn\xFDm zdrojom organiz\xE1cie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyu\u017E\xEDvanie intern\xFDch produktov, legislat\xEDvnych port\xE1lov a publik\xE1ci\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dostupnos\u0165 arch\xEDvu video\u0161kolen\xED a vzdel\xE1vac\xEDch materi\xE1lov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podpora samostatn\xE9ho \u0161t\xFAdia a pr\xEDpravy na v\xFDu\u010Dbu."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "6. Zabezpe\u010Di\u0165 objekt\xEDvny, transparentn\xFD a motiva\u010Dn\xFD syst\xE9m hodnotenia:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnotenie na z\xE1klade sp\xE4tnej v\xE4zby \xFA\u010Dastn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pravideln\xE1 rev\xEDzia kvality lektorsk\xFDch v\xFDstupov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: "1.2 Dopl\u0148uj\xFAce \u0161pecifick\xE9 ciele strat\xE9gie"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "1. Zvy\u0161ova\u0165 kvalitu vzdel\xE1vac\xEDch produktov:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podpora inov\xE1ci\xED v r\xE1mci tvorby kurzov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "aplik\xE1cia modern\xFDch didaktick\xFDch a digit\xE1lnych n\xE1strojov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "rozvoj multimedi\xE1lnych foriem vzdel\xE1vania."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "2. Udr\u017Eiava\u0165 vysok\xFD profesion\xE1lny \u0161tandard lektorsk\xE9ho t\xEDmu:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dodr\u017Eiavanie etick\xE9ho k\xF3dexu lektora,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "profesion\xE1lne vystupovanie a reprezent\xE1cia organiz\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pravideln\xE9 aktualizovanie odborn\xE9ho profilu lektora."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "3. Podporova\u0165 adaptabilitu na nov\xE9 technol\xF3gie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "rozvoj digit\xE1lnych kompetenci\xED lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podpora pri pr\xE1ci s online platformami,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "aplik\xE1cia interakt\xEDvnych prvkov do v\xFDu\u010Dby."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "2.3 O\u010Dak\xE1van\xE9 pr\xEDnosy strat\xE9gie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "stabiln\xE1 a kvalitn\xE1 sie\u0165 lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vy\u0161\u0161ia odborn\xE1 \xFArove\u0148 a aktu\xE1lnos\u0165 vzdel\xE1vac\xEDch programov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zv\xFD\u0161en\xE1 spokojnos\u0165 \xFA\u010Dastn\xEDkov kurzov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "efekt\xEDvnej\u0161ie pl\xE1novanie a riadenie vzdel\xE1vac\xEDch kapac\xEDt,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vy\u0161\u0161ia konkurencieschopnos\u0165 organiz\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dlhodob\xE1 udr\u017Eate\u013Enos\u0165 a profesionaliz\xE1cia vzdel\xE1vac\xEDch procesov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Hlavn\xE9 ciele:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Zabezpe\u010Di\u0165 vysok\xFA \xFArove\u0148 odborn\xFDch a pedagogick\xFDch kompetenci\xED lektorov."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Podporova\u0165 kontinu\xE1lne vzdel\xE1vanie lektorov formou kurzov, \u0161kolen\xED a certifikovan\xFDch programov."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Vytvori\u0165 syst\xE9m umo\u017E\u0148uj\xFAci pl\xE1novan\xFD profesijn\xFD rast lektorov."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Rozv\xEDja\u0165 kult\xFAru zdie\u013Eania sk\xFAsenost\xED, spolupr\xE1ce a odborn\xE9ho rozvoja."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Poskytn\xFA\u0165 lektorom pr\xEDstup k vzdel\xE1vac\xEDm a produktov\xFDm zdrojom spolo\u010Dnosti Poradca podnikate\u013Ea."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Zabezpe\u010Di\u0165 objekt\xEDvny a transparentn\xFD syst\xE9m hodnotenia lektorov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\xA0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "2. V\xDDCHODISK\xC1 ROZVOJA \u013DUDSK\xDDCH ZDROJOV"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Te\xF3ria rozvoja \u013Eudsk\xFDch zdrojov sa opiera o interdisciplin\xE1rny pr\xEDstup \u010Derpaj\xFAci z andragogiky, pedagogiky, psychol\xF3gie, mana\u017Ementu, organiza\u010Dn\xE9ho rozvoja a modern\xFDch konceptov celo\u017Eivotn\xE9ho vzdel\xE1vania. Vzdel\xE1vacie in\u0161tit\xFAcie, ktor\xE9 sa zameriavaj\xFA na odborn\xE9 a profesijn\xE9 vzdel\xE1vanie dospel\xFDch, musia tieto teoretick\xE9 smerovania zoh\u013Ead\u0148ova\u0165 pri tvorbe syst\xE9mov vzdel\xE1vania, hodnotenia a podpory lektorsk\xE9ho t\xEDmu."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "2.1 Andragogick\xE9 princ\xEDpy vzdel\xE1vania dospel\xFDch"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Andragogika ako te\xF3ria vzdel\xE1vania dospel\xFDch zd\xF4raz\u0148uje \u0161pecifik\xE1, ktor\xE9 odli\u0161uj\xFA dospel\xE9ho \xFA\u010Dastn\xEDka od detsk\xE9ho \u017Eiaka. V kontexte lektorskej pr\xE1ce predstavuj\xFA tieto princ\xEDpy prvotn\xFD metodick\xFD r\xE1mec:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "zameranie na praktickos\u0165 a okam\u017Eit\xFA vyu\u017Eite\u013Enos\u0165 poznatkov"
        }), " \u2013 dospel\xED preferuj\xFA aplikovate\u013En\xE9 rie\u0161enia a konkr\xE9tne pr\xEDklady z praxe;"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "auton\xF3mia a sebariadenie vo vzdel\xE1van\xED"
        }), " \u2013 dospel\xFD \xFA\u010Dastn\xEDk o\u010Dak\xE1va partnersk\xFD pr\xEDstup a mo\u017Enos\u0165 ovplyv\u0148ova\u0165 priebeh v\xFDu\u010Dby;"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "vych\xE1dzanie zo sk\xFAsenost\xED \xFA\u010Dastn\xEDkov"
        }), " \u2013 sk\xFAsenos\u0165 je z\xE1kladn\xFDm u\u010Debn\xFDm zdrojom, ktor\xFD lektor vyu\u017E\xEDva pri tvorbe dynamick\xE9ho obsahu;"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "orient\xE1cia na rie\u0161enie probl\xE9mov"
        }), " \u2013 efekt\xEDvne vzdel\xE1vanie dospel\xFDch je zalo\u017Een\xE9 na modelov\xFDch situ\xE1ci\xE1ch a praktick\xFDch \xFAloh\xE1ch;"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "potreba vidie\u0165 zmysel vzdel\xE1vania"
        }), " \u2013 motiv\xE1cia sa zvy\u0161uje, ke\u010F \xFA\u010Dastn\xEDk ch\xE1pe priamy pr\xEDnos obsahu pre svoju pr\xE1cu."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Tieto princ\xEDpy z\xE1sadne ovplyv\u0148uj\xFA metodiku lektora, sp\xF4sob pr\xEDpravy kurzov a v\xFDber vzdel\xE1vac\xEDch n\xE1strojov."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "2.2 Kompeten\u010Dn\xFD model rozvoja lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Rozvoj lektorov vych\xE1dza z jasne definovan\xE9ho kompeten\u010Dn\xE9ho profilu. Vzdel\xE1vacia organiz\xE1cia pracuje najm\xE4 s t\xFDmito kompeten\u010Dn\xFDmi oblas\u0165ami:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "1. Odborn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "aktu\xE1lne a prehlbuj\xFAce sa odborn\xE9 vedomosti,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "znalos\u0165 legislat\xEDvnych noriem a ich v\xFDkladu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 spracova\u0165 odborn\xE9 t\xE9my do vzdel\xE1vac\xEDch v\xFDstupov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "2. Pedagogick\xE9 a didaktick\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 \u0161trukt\xFArova\u0165 u\u010Debn\xFD obsah,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyu\u017E\xEDvanie modern\xFDch vzdel\xE1vac\xEDch met\xF3d,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vedenie diskusie, facilit\xE1cia a hodnotenie \xFA\u010Dastn\xEDkov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "3. Komunika\u010Dn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "jasn\xE9, zrozumite\u013En\xE9 a profesion\xE1lne vystupovanie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 motivova\u0165, odpoveda\u0165 na ot\xE1zky a reagova\u0165 na potreby \xFA\u010Dastn\xEDkov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4. Digit\xE1lne kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pr\xE1ca s online vzdel\xE1vac\xEDmi platformami,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "tvorba multimedi\xE1lneho obsahu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyu\u017E\xEDvanie interakt\xEDvnych digit\xE1lnych n\xE1strojov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "5. Prezenta\u010Dn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vizu\xE1lna, verb\xE1lna a neverb\xE1lna str\xE1nka prezent\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pr\xE1ca s hlasom, priestorom, dynamikou v\xFDu\u010Dby."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "2.3 Syst\xE9mov\xFD pr\xEDstup k rozvoju \u013Eudsk\xFDch zdrojov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Te\xF3ria syst\xE9mov\xE9ho riadenia HRD zd\xF4raz\u0148uje, \u017Ee rozvoj mus\xED by\u0165:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "pl\xE1novan\xFD"
        }), " \u2013 definovan\xFD v ro\u010Dn\xFDch a strategick\xFDch pl\xE1noch,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "kontinu\xE1lny"
        }), " \u2013 nie jednorazov\xFD, ale prebiehaj\xFAci priebe\u017Ene,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "cie\u013Eovo orientovan\xFD"
        }), " \u2013 zameran\xFD na konkr\xE9tne kompetencie,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "hodnoten\xFD a merate\u013En\xFD"
        }), " \u2013 s jasn\xFDmi ukazovate\u013Emi kvality,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "prepojen\xFD s potrebami organiz\xE1cie"
        }), " \u2013 reflektuj\xFAci aktu\xE1lne po\u017Eiadavky trhu a klientov."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9mov\xFD pr\xEDstup umo\u017E\u0148uje vytv\xE1ranie ucelen\xFDch procesov \u2013 od anal\xFDzy potrieb cez pl\xE1novanie a\u017E po sp\xE4tn\xFA v\xE4zbu a \xFApravu rozvojov\xFDch programov."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "3.4 Koncept celo\u017Eivotn\xE9ho vzdel\xE1vania (Lifelong Learning)"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Modern\xE9 vzdel\xE1vacie organiz\xE1cie stavaj\xFA na filozofii celo\u017Eivotn\xE9ho vzdel\xE1vania, ktor\xE9 zah\u0155\u0148a:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kontinu\xE1lne udr\u017Eiavanie odborn\xFDch poznatkov v aktu\xE1lnom stave,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "reagovanie na r\xFDchle legislat\xEDvne a technologick\xE9 zmeny,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "roz\u0161irovanie profesijn\xE9ho profilu lektora,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "motiv\xE1ciu neust\xE1le pracova\u0165 na svojom vzdel\xE1van\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Celo\u017Eivotn\xE9 vzdel\xE1vanie podporuje flexibilitu lektora a jeho schopnos\u0165 prisp\xF4sobi\u0165 obsah aktu\xE1lnym potreb\xE1m praxe."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "2.4 Profesijn\xE9 vzdel\xE1vanie a odborn\xE1 \u0161pecializ\xE1cia"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Profesijn\xE9 vzdel\xE1vanie je neoddelite\u013Enou s\xFA\u010Das\u0165ou rozvoja odborn\xEDkov v r\xF4znych oblastiach. V kontexte lektorskej pr\xE1ce zah\u0155\u0148a:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "prehlbovanie \u0161pecializ\xE1cie v konkr\xE9tnej oblasti,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "\xFA\u010Das\u0165 na odborn\xFDch konferenci\xE1ch a semin\xE1roch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "nadob\xFAdanie certifik\xE1tov a akreditovan\xFDch kvalifik\xE1ci\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "sledovanie odborn\xFDch trendov a inov\xE1ci\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Tento typ rozvoja zaru\u010Duje, \u017Ee lektori poskytuj\xFA obsah, ktor\xFD je aktu\xE1lny, presn\xFD a v s\xFAlade s najnov\u0161ou odbornou praxou."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "2.5 Psychologick\xE9 a motiva\u010Dn\xE9 aspekty vzdel\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Teoretick\xE9 v\xFDchodisk\xE1 HRD zah\u0155\u0148aj\xFA aj pochopenie motiv\xE1cie a psychol\xF3gie dospel\xE9ho \xFA\u010Dastn\xEDka:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "potreba uznania a sebarealiz\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vn\xFAtorn\xE1 motiv\xE1cia k u\u010Deniu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "individu\xE1lne u\u010Debn\xE9 \u0161t\xFDly,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "potreba bezpe\u010Dn\xE9ho a podporuj\xFAceho vzdel\xE1vacieho prostredia."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektor, ktor\xFD tieto aspekty ovl\xE1da, dok\xE1\u017Ee efekt\xEDvnej\u0161ie vies\u0165 skupinu a zvy\u0161ova\u0165 kvalitu vzdel\xE1vacieho z\xE1\u017Eitku."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "2.6 Digit\xE1lna transform\xE1cia vo vzdel\xE1van\xED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Modern\xE9 teoretick\xE9 pr\xEDstupy zd\xF4raz\u0148uj\xFA digitaliz\xE1ciu ako nevyhnutn\xFA s\xFA\u010Das\u0165 vzdel\xE1vania:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "prechod na hybridn\xE9 a online form\xE1ty,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pou\u017E\xEDvanie interakt\xEDvnych digit\xE1lnych n\xE1strojov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "tvorba e-learningov\xFDch modulov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyu\u017E\xEDvanie video\u0161kolen\xED a virtu\xE1lnych u\u010Debn\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Digit\xE1lna transform\xE1cia vytv\xE1ra nov\xE9 mo\u017Enosti rozvoja lektorov a z\xE1rove\u0148 zvy\u0161uje dostupnos\u0165 a efektivitu vzdel\xE1vania."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\xA0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "\xA0"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "3. CHARAKTERISTIKA ORGANIZ\xC1CIE A LEKTORSK\xC9HO Z\xC1ZEMIA"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Rozvoj \u013Eudsk\xFDch zdrojov je v\u017Edy podmienen\xFD kvalitou organiza\u010Dn\xE9ho prostredia, jeho kult\xFArou a infra\u0161trukt\xFArou, v ktorej odborn\xED pracovn\xEDci p\xF4sobia. Preto je pre spr\xE1vne nastavenie strat\xE9gie rozvoja lektorov nevyhnutn\xE9 najsk\xF4r definova\u0165 samotn\xE9 fungovanie platformy Profivzdel\xE1vanie.sk, jej vzdel\xE1vaciu filozofiu, organiza\u010Dn\xFD model, ako aj \u0161pecifik\xE1 intern\xE9ho a extern\xE9ho lektorsk\xE9ho t\xEDmu. T\xE1to kapitola poskytuje ucelen\xFD poh\u013Ead na organiza\u010Dn\xE9 z\xE1zemie a podmienky, ktor\xE9 tvoria z\xE1klad pre efekt\xEDvnu realiz\xE1ciu vzdel\xE1vac\xEDch aktiv\xEDt a udr\u017Eiavanie vysokej odbornej \xFArovne lektorskej pr\xE1ce."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Profivzdel\xE1vanie.sk predstavuje modern\xFA vzdel\xE1vaciu platformu, ktor\xE1 integruje tradi\u010Dn\xE9 princ\xEDpy odborn\xE9ho vzdel\xE1vania s digit\xE1lnymi technol\xF3giami a inovat\xEDvnymi metodikami u\u010Denia. V r\xE1mci svojho p\xF4sobenia zais\u0165uje odborn\xE9, legislat\xEDvne a profesijn\xE9 vzdel\xE1vanie pre \u0161irok\xE9 spektrum \xFA\u010Dastn\xEDkov \u2013 od verejnej spr\xE1vy cez podnikate\u013Esk\xE9 subjekty a\u017E po odborn\xFA verejnos\u0165. K\u013E\xFA\u010Dov\xFDm faktorom \xFAspechu je pritom kvalitn\xE1 spolupr\xE1ca s lektormi, ktor\xED tvoria jadro eduka\u010Dn\xE9ho procesu a ur\u010Duj\xFA jeho odborn\xFA aj metodick\xFA \xFArove\u0148."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Nasleduj\xFAce podkapitoly konkretizuj\xFA hlavn\xE9 charakteristiky organiz\xE1cie a opisuj\xFA k\u013E\xFA\u010Dov\xE9 komponenty jej lektorsk\xE9ho z\xE1zemia."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.1 Charakteristika organiz\xE1cie Profivzdel\xE1vanie.sk"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Profivzdel\xE1vanie.sk je s\xFA\u010Das\u0165ou spolo\u010Dnosti Poradca podnikate\u013Ea, ktor\xE1 patr\xED medzi dlhoro\u010Dn\xE9 a re\u0161pektovan\xE9 subjekty p\xF4sobiace v oblasti odborn\xE9ho informa\u010Dn\xE9ho servisu, legislat\xEDvnych rie\u0161en\xED a vzdel\xE1vania. Platforma sa \u0161pecializuje na:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "online vzdel\xE1vanie"
        }), " prostredn\xEDctvom webin\xE1rov, predn\xE1\u0161ok, odborn\xFDch vide\xED a interakt\xEDvnych kurzov,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "prezen\u010Dn\xE9 \u0161kolenia"
        }), " realizovan\xE9 v modern\xFDch \u0161koliacich priestoroch,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "konferen\u010Dn\xE9 podujatia"
        }), " pre odborn\xFA verejnos\u0165,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "vzdel\xE1vac\xED obsah"
        }), " vytv\xE1ran\xFD v spolupr\xE1ci s expertmi z praxe a legislat\xEDvy."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Organiza\u010Dn\xFD model platformy je postaven\xFD na flexibilite, odbornej relevantnosti a na schopnosti r\xFDchlo reagova\u0165 na meniace sa potreby trhu a legislat\xEDvne po\u017Eiadavky. \u0160trukt\xFAra t\xEDmu zah\u0155\u0148a mana\u017E\xE9rske, metodick\xE9, produk\u010Dn\xE9 a technick\xE9 poz\xEDcie, ktor\xE9 spolo\u010Dne zabezpe\u010Duj\xFA kompletn\xFD proces vzdel\xE1vania \u2013 od tvorby programu a\u017E po jeho hodnotenie."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.2 Filozofia vzdel\xE1vania a odborn\xE9 \u0161tandardy"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Vzdel\xE1vacia platforma sa riadi princ\xEDpmi profesionality, odbornosti, objektivity a dostupnosti vzdel\xE1vania. V r\xE1mci svojej filozofie kladie d\xF4raz na:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "poskytovanie aktu\xE1lneho a legislat\xEDvne spr\xE1vneho obsahu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyu\u017E\xEDvanie modern\xFDch didaktick\xFDch met\xF3d,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vysok\xFD \u0161tandard technick\xE9ho a produk\u010Dn\xE9ho spracovania \u0161kolen\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kontinu\xE1lne zvy\u0161ovanie kvality lektorsk\xE9ho t\xEDmu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "budovanie dlhodob\xFDch partnerstiev s odborn\xEDkmi."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.3 Lektorsk\xFD t\xEDm \u2013 \u0161trukt\xFAra a profil"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektorsk\xFD t\xEDm Profivzdel\xE1vanie.sk je tvoren\xFD kombin\xE1ciou intern\xFDch odborn\xEDkov a extern\xFDch spolupracovn\xEDkov. Tak\xFDto model umo\u017E\u0148uje platforme pokr\xFDva\u0165 \u0161irok\xE9 spektrum t\xE9m, flexibilne reagova\u0165 na nov\xE9 po\u017Eiadavky a s\xFA\u010Dasne udr\u017Eiava\u0165 vysok\xFA \xFArove\u0148 kvality."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "3.3.1 Intern\xED lektori"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Intern\xED lektori s\xFA odborn\xED pracovn\xEDci spolo\u010Dnosti Poradca podnikate\u013Ea, ktor\xED:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "participuj\xFA na tvorbe vzdel\xE1vac\xEDch produktov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pravidelne zabezpe\u010Duj\xFA \u0161kolenia vo svojich odborn\xFDch oblastiach,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "spolupracuj\xFA na aktualiz\xE1ci\xE1ch legislat\xEDvnych obsahov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "s\xFA zapojen\xED do metodickej koordin\xE1cie."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "3.3.2 Extern\xED lektori"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Extern\xED lektori s\xFA partneri platformy, ktor\xED s\xFA do vzdel\xE1vacieho procesu zap\xE1jan\xED na z\xE1klade odbornosti, sk\xFAsenost\xED a profesijn\xE9ho profilu. Od extern\xFDch lektorov sa vy\u017Eaduje:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "preuk\xE1zate\u013En\xE1 prax a odborn\xE9 kompetencie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 prezentova\u0165 odborn\xE9 t\xE9my zrozumite\u013Ene a didakticky spr\xE1vne,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 reagova\u0165 na dopyty a potreby \xFA\u010Dastn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dodr\u017Eiavanie intern\xFDch \u0161tandardov platformy."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.4 Organiza\u010Dn\xE9 a technick\xE9 z\xE1zemie pre vzdel\xE1vanie"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Medzi hlavn\xE9 prvky patria:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "profesion\xE1lne technick\xE9 rie\u0161enia pre online \u0161kolenia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vlastn\xE9 produk\u010Dn\xE9 a prenosov\xE9 \u0161t\xFAdio,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "modern\xE9 prezen\u010Dn\xE9 \u0161koliace miestnosti,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "intern\xE9 softv\xE9rov\xE9 n\xE1stroje na spr\xE1vu kurzov, \xFA\u010Dastn\xEDkov a lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podporn\xE9 oddelenia \u2013 technick\xE1 podpora, marketing, produkcia."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Toto z\xE1zemie umo\u017E\u0148uje lektorom plne sa s\xFAstredi\u0165 na odborn\xFA str\xE1nku \u0161kolenia, zatia\u013E \u010Do organiza\u010Dn\xFA, technick\xFA a produk\u010Dn\xFA podporu zabezpe\u010Duje t\xEDm platformy."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.5 Spolupr\xE1ca s lektormi a jej syst\xE9mov\xE9 ukotvenie"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Spolupr\xE1ca s lektormi je formalizovan\xE1 prostredn\xEDctvom zmluvn\xFDch vz\u0165ahov, intern\xFDch smern\xEDc a procesov. Tieto dokumenty upravuj\xFA:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podmienky v\xFDkonu lektorskej \u010Dinnosti,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "autorsk\xE9 pr\xE1va k vzdel\xE1vac\xEDm materi\xE1lom,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "po\u017Eiadavky na kvalitu obsahu a prezent\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnotenie spokojnosti \xFA\u010Dastn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "postupy pri aktualiz\xE1cii a tvorbe nov\xFDch kurzov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m je nastaven\xFD tak, aby podporoval transparentnos\u0165, efektivitu aj odborn\xFD rast lektora."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "3.6 Siln\xE9 str\xE1nky lektorsk\xE9ho z\xE1zemia"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Medzi hlavn\xE9 prednosti platformy v oblasti lektorsk\xE9ho z\xE1zemia patria:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "\u0161irok\xE1 sie\u0165 odborn\xEDkov z praxe a legislat\xEDvy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dlhodob\xE9 partnerstv\xE1,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vysok\xE1 odbornos\u0165 a aktu\xE1lnos\u0165 t\xE9m,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "modern\xE9 technick\xE9 a produk\u010Dn\xE9 vybavenie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podpora kontinu\xE1lneho profesijn\xE9ho rozvoja,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kvalitn\xE9 intern\xE9 procesy a podpora zo strany organiza\u010Dn\xE9ho t\xEDmu."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Tieto faktory vytv\xE1raj\xFA pevn\xFD z\xE1klad pre kvalitn\xFA a udr\u017Eate\u013En\xFA realiz\xE1ciu vzdel\xE1vania."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\xA0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "\xA0"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "4. SYST\xC9M ROZVOJA LEKTOROV NA PROFIVZDEL\xC1VANIE.SK"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Kvalitn\xFD lektor je nosite\u013Eom odbornosti, garantom spr\xE1vnej interpret\xE1cie legislat\xEDvy a v\xFDznamn\xFDm faktorom spokojnosti \xFA\u010Dastn\xEDkov vzdel\xE1vania. Aby organiz\xE1cia zabezpe\u010Dila vysok\xFA \xFArove\u0148 vzdel\xE1vac\xEDch slu\u017Eieb, buduje ucelen\xFD syst\xE9m rozvoja lektorov, ktor\xFD podporuje ich odborn\xFD, metodick\xFD aj osobnostn\xFD rast."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Tento syst\xE9m je zalo\u017Een\xFD na princ\xEDpoch kontinuity, dostupnosti, odbornosti a partnerskej spolupr\xE1ce. Podporuje lektorov v ich profesijnom napredovan\xED, umo\u017E\u0148uje im zdokona\u013Eova\u0165 si pedagogick\xE9 a prezenta\u010Dn\xE9 zru\u010Dnosti a z\xE1rove\u0148 im poskytuje n\xE1stroje na sledovanie modern\xFDch trendov v oblasti vzdel\xE1vania."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m rozvoja lektorov pozost\xE1va z viacer\xFDch vzdel\xE1vac\xEDch, metodick\xFDch a podporn\xFDch aktiv\xEDt, ktor\xE9 spolo\u010Dne vytv\xE1raj\xFA komplexn\xFD r\xE1mec pre udr\u017Eanie vysokej kvality lektorskej pr\xE1ce."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.1 Princ\xEDpy syst\xE9mu rozvoja lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m je budovan\xFD na t\xFDchto z\xE1kladn\xFDch princ\xEDpoch:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Odbornos\u0165 a aktu\xE1lnos\u0165"
        }), " \u2013 lektori maj\xFA neust\xE1ly pr\xEDstup k odborn\xFDm zdrojom, legislat\xEDvnym novink\xE1m a relevantn\xFDm inform\xE1ci\xE1m."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Dostupnos\u0165 vzdel\xE1vania"
        }), " \u2013 lektorom je poskytovan\xFD \u0161irok\xFD v\xFDber vzdel\xE1vac\xEDch aktiv\xEDt a materi\xE1lov bez dodato\u010Dn\xFDch finan\u010Dn\xFDch bari\xE9r."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Flexibilita"
        }), " \u2013 lektori si m\xF4\u017Eu vybera\u0165 formu a tempo svojho profesijn\xE9ho rozvoja pod\u013Ea individu\xE1lnych potrieb a oblasti p\xF4sobenia."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Praktickos\u0165"
        }), " \u2013 d\xF4raz sa kladie na vyu\u017Eite\u013Enos\u0165 z\xEDskan\xFDch poznatkov v re\xE1lnej eduka\u010Dnej praxi."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Partnerstvo a spolupr\xE1ca"
        }), " \u2013 platforma vytv\xE1ra priestor pre dial\xF3g, sp\xE4tn\xFA v\xE4zbu a spolo\u010Dn\xE9 zvy\u0161ovanie kvality vzdel\xE1vania."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Transparentnos\u0165"
        }), " \u2013 pravidl\xE1 a procesy s\xFA jasne definovan\xE9, \u010Do zabezpe\u010Duje f\xE9rov\xE9 podmienky pre v\u0161etk\xFDch lektorov."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.2 Oblasti rozvoja lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m zah\u0155\u0148a tri hlavn\xE9 oblasti:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.2.1 Odborn\xFD rozvoj"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Zameran\xFD na prehlbovanie odbornosti, legislat\xEDvnych vedomost\xED a \u0161pecializ\xE1cie."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.2.2 Didakticko-metodick\xFD rozvoj"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Zameran\xFD na rozvoj pedagogick\xFDch, prezenta\u010Dn\xFDch a komunika\u010Dn\xFDch zru\u010Dnost\xED."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.2.3 Osobnostn\xFD a profesion\xE1lny rozvoj"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Podporuje soft skills, digit\xE1lne kompetencie a schopnos\u0165 adaptova\u0165 sa na modern\xE9 trendy vo vzdel\xE1van\xED."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.3 Dostupn\xE9 formy a n\xE1stroje rozvoja lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Platforma Profivzdel\xE1vanie.sk poskytuje lektorom rozsiahly s\xFAbor vzdel\xE1vac\xEDch mo\u017Enost\xED. Tento syst\xE9m je kombin\xE1ciou form\xE1lnych, neform\xE1lnych a auton\xF3mnych foriem vzdel\xE1vania."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.3.1 Bezplatn\xFD pr\xEDstup k vzdel\xE1vac\xEDm produktom Poradcu podnikate\u013Ea"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektori maj\xFA mo\u017Enos\u0165:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "bezplatne vyu\u017E\xEDva\u0165 kompletn\xE9 portf\xF3lio odborn\xFDch produktov spolo\u010Dnosti,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "z\xEDskava\u0165 aktu\xE1lne inform\xE1cie z legislat\xEDvnych oblasti prostredn\xEDctvom odborn\xFDch publik\xE1ci\xED, aktual\xEDt a koment\xE1rov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyu\u017E\xEDva\u0165 digit\xE1lne n\xE1stroje a informa\u010Dn\xE9 datab\xE1zy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "sledova\u0165 trendy v odborn\xFDch t\xE9mach, ktor\xE9 s\xFA z\xE1rove\u0148 t\xE9mami \u0161kolen\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.3.2 \xDA\u010Das\u0165 na online \u0161koleniach a webin\xE1roch"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektorom je umo\u017Enen\xE9:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "z\xFA\u010Dast\u0148ova\u0165 sa v\u0161etk\xFDch online \u0161kolen\xED platformy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "sledova\u0165 pr\xE1cu ostatn\xFDch lektorov, \u010D\xEDm z\xEDskavaj\xFA nov\xE9 metodick\xE9 a prezenta\u010Dn\xE9 podnety,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "analyzova\u0165 modern\xE9 pr\xEDstupy k pr\xE1ci s publikom,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "porovn\xE1va\u0165 r\xF4zne \u0161t\xFDly v\xFDkladu a prezent\xE1cie."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\xDA\u010Das\u0165 je bezplatn\xE1 a \u010Dasovo flexibiln\xE1."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.3.3 \xDA\u010Das\u0165 na odborn\xFDch konferenci\xE1ch"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektori platformy maj\xFA:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "mo\u017Enos\u0165 bezplatnej \xFA\u010Dasti na odborn\xFDch konferenci\xE1ch Poradcu podnikate\u013Ea,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pr\xEDle\u017Eitos\u0165 z\xEDska\u0165 preh\u013Ead o aktu\xE1lnych trendoch a odborn\xFDch probl\xE9moch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "priestor na networking s expertmi a odbornou verejnos\u0165ou,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "mo\u017Enos\u0165 prezentova\u0165 vlastn\xE9 t\xE9my (v pr\xEDpade v\xFDberu)."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.3.4 Pravideln\xE1 sp\xE4tn\xE1 v\xE4zba a hodnotenie"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Hodnotenie je koncipovan\xE9 ako n\xE1stroj rastu, nie kontroly."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m zah\u0155\u0148a:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnotenie \xFA\u010Dastn\xEDkmi \u0161kolen\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "intern\xE9 hodnotenie kvality prezent\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "priebe\u017En\xE9 sledovanie odborn\xFDch kompetenci\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "anal\xFDzu siln\xFDch str\xE1nok a odpor\xFA\u010Dan\xED pre zlep\u0161enie."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "V\xFDstupy tvoria z\xE1klad pre pl\xE1n individu\xE1lneho rozvoja."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.3.7 Samostatn\xE9 \u0161t\xFAdium a intern\xE9 materi\xE1ly"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektorom je spr\xEDstupnen\xFD:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "intern\xFD metodick\xFD manu\xE1l,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "odpor\xFA\u010Dan\xE9 postupy pre online aj prezen\u010Dn\xE9 vzdel\xE1vanie,"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.4 Proces pl\xE1novania a riadenia rozvoja lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Rozvoj lektorov je riaden\xFD v s\xFAlade s ro\u010Dn\xFDm pl\xE1nom vzdel\xE1vac\xEDch aktiv\xEDt platformy."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m zah\u0155\u0148a:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.4.1 Identifik\xE1ciu potrieb:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "anal\xFDza sp\xE4tnej v\xE4zby \xFA\u010Dastn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnotenie lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "legislat\xEDvne zmeny,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "nov\xE9 odborn\xE9 t\xE9my,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "potreby platformy."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.4.2 Pl\xE1novanie rozvoja:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "ka\u017Edoro\u010Dn\xFD pl\xE1n rozvoja lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "odpor\xFA\u010Dan\xE9 \u0161kolenia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "n\xE1vrh intern\xFDch workshopov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pr\xEDstup k odborn\xFDm zdrojom."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.4.3 Realiz\xE1ciu rozvojov\xFDch aktiv\xEDt:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Denie organiza\u010Dnej a technickej podpory,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "informovanie lektorov o mo\u017Enostiach vzdel\xE1vania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pravideln\xE9 aktualiz\xE1cie intern\xFDch materi\xE1lov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "4.4.4 Hodnotenie efektivity rozvoja:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnotenie kvality vzdel\xE1vania pred a po absolvovan\xED aktiv\xEDt,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "sledovanie profesijn\xE9ho progresu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pravideln\xE1 aktualiz\xE1cia syst\xE9mu podpory."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "4.5 V\xFDhody syst\xE9mu rozvoja lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m poskytuje lektorom viacero benefitov, napr.:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "bezplatn\xE9 odborn\xE9 vzdel\xE1vanie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pr\xEDstup k aktu\xE1lnym inform\xE1ci\xE1m,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "posil\u0148ovanie prezenta\u010Dn\xFDch zru\u010Dnost\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podpora pri tvorbe materi\xE1lov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "mo\u017Enos\u0165 kari\xE9rneho rastu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "partnersk\xFD vz\u0165ah a profesion\xE1lne prostredie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "roz\u0161\xEDrenie odborn\xE9ho profilu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "stabiln\xE9 a kvalitn\xE9 technick\xE9 podmienky."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Pl\xE1novanie rozvoja a vzdel\xE1vac\xEDch potrieb"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Proces pl\xE1novania zah\u0155\u0148a:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "anal\xFDzu potrieb vzdel\xE1vania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "identifik\xE1ciu rozvojov\xFDch oblast\xED lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pl\xE1novanie \xFA\u010Dasti na odborn\xFDch podujatiach."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Intern\xE9 a extern\xE9 vzdel\xE1vanie lektorov"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Lektori maj\xFA k dispoz\xEDcii:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "intern\xE9 metodick\xE9 \u0161kolenia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "\u0161kolenia zameran\xE9 na tvorbu obsahu a modern\xE9 vzdel\xE1vacie met\xF3dy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "extern\xE9 odborn\xE9 \u0161kolenia od partnersk\xFDch organiz\xE1ci\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Odborn\xE9 konferencie a profesijn\xE9 podujatia"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Organiz\xE1cia umo\u017E\u0148uje lektorom \xFA\u010Das\u0165 na:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "odborn\xFDch konferenci\xE1ch Poradcu podnikate\u013Ea,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "partnersk\xFDch odborn\xFDch podujatiach,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "tematick\xFDch workshopoch."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Mentoring, kou\u010Ding a intern\xE1 spolupr\xE1ca"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Podpora zah\u0155\u0148a:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "mentoring sk\xFAsen\xFDch lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "individu\xE1lne konzult\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "spolo\u010Dn\xFA tvorbu \u0161kolen\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "intern\xE9 hodnotiace stretnutia."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Pr\xEDstup k produktom Poradca podnikate\u013Ea"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["Lektori maj\xFA mo\u017Enos\u0165 ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "bezplatne vyu\u017E\xEDva\u0165 v\u0161etky produkty PP"
      }), ", ak o ne prejavia z\xE1ujem. Zah\u0155\u0148a to:"]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "odborn\xE9 publik\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "legislat\xEDvne port\xE1ly,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "online n\xE1stroje,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "mesa\u010Dn\xEDky a magaz\xEDny,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "video\u0161kolenia a arch\xEDv kurzov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\xA0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "\xA0"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "5. SYST\xC9M HODNOTENIA LEKTOROV"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Efekt\xEDvny syst\xE9m hodnotenia je neoddelite\u013Enou s\xFA\u010Das\u0165ou rozvoja \u013Eudsk\xFDch zdrojov. Umo\u017E\u0148uje identifikova\u0165 siln\xE9 str\xE1nky lektorov, zlep\u0161i\u0165 ich pedagogick\xE9 a odborn\xE9 kompetencie, optimalizova\u0165 obsah vzdel\xE1vania a zabezpe\u010Di\u0165 spokojnos\u0165 \xFA\u010Dastn\xEDkov. Hodnotenie m\xE1 z\xE1rove\u0148 motiva\u010Dn\xFA funkciu, ke\u010F\u017Ee poskytuje lektorom jasn\xFA sp\xE4tn\xFA v\xE4zbu a konkr\xE9tne odpor\xFA\u010Dania pre profesion\xE1lny rast."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m hodnotenia na platforme Profivzdel\xE1vanie.sk je navrhnut\xFD tak, aby bol objekt\xEDvny, transparentn\xFD, pravideln\xFD a prepojen\xFD s pl\xE1nom rozvoja lektorov."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.1 Princ\xEDpy hodnotenia"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m hodnotenia sa riadi nasledovn\xFDmi princ\xEDpmi:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "objekt\xEDvnos\u0165"
        }), " \u2013 hodnotenie je zalo\u017Een\xE9 na jasne definovan\xFDch krit\xE9ri\xE1ch a merate\u013En\xFDch ukazovate\u013Eoch,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "transparentnos\u0165"
        }), " \u2013 lektori s\xFA obozn\xE1men\xED s hodnotiacimi krit\xE9riami a postupmi,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "pravidelnos\u0165"
        }), " \u2013 hodnotenie prebieha systematicky po ukon\u010Den\xED \u0161kolenia a minim\xE1lne raz ro\u010Dne vo forme komplexnej rev\xEDzie,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "podporn\xE1 funkcia"
        }), " \u2013 cie\u013Eom je identifikova\u0165 oblasti na zlep\u0161enie a podpori\u0165 profesijn\xFD rast, nie kontrola \u010Di trestanie."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.2 Formy hodnotenia lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Hodnotenie zah\u0155\u0148a kombin\xE1ciu kvantitat\xEDvnych a kvalitat\xEDvnych met\xF3d:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "5.2.1 Sp\xE4tn\xE1 v\xE4zba \xFA\u010Dastn\xEDkov \u0161kolenia:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dotazn\xEDky a hodnotiace formul\xE1re po ka\u017Edom kurze alebo webin\xE1ri,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnotenie odbornosti, zrozumite\u013Enosti, metodiky a dynamiky \u0161kolenia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "identifik\xE1cia oblast\xED, ktor\xE9 je potrebn\xE9 zlep\u0161i\u0165,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "anonymn\xE9 hodnotenie pre objekt\xEDvnej\u0161\xED poh\u013Ead."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "5.2.2 Intern\xE9 hodnotenie lektorsk\xE9ho t\xEDmu:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "metodick\xE9 pos\xFAdenie obsahu \u0161kolenia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kontrola konzistencie, aktu\xE1lnosti a presnosti inform\xE1ci\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnotenie prezent\xE1cie a didaktick\xFDch pr\xEDstupov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "odpor\xFA\u010Dania pre \u010Fal\u0161\xED rozvoj."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "5.2.3 Sebahodnotenie lektora:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "reflexia vlastn\xE9ho v\xFDkonu a identifik\xE1cia siln\xFDch a slab\xFDch str\xE1nok,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "z\xE1pis do individu\xE1lneho rozvojov\xE9ho pl\xE1nu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "prepojenie sebareflexie s pl\xE1novan\xFDm vzdel\xE1van\xEDm a rozvojom kompetenci\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.3 Hodnotiace krit\xE9ri\xE1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Pre zaru\u010Denie jednotnosti a objekt\xEDvnosti s\xFA definovan\xE9 jasn\xE9 hodnotiace krit\xE9ri\xE1:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "odbornos\u0165 a aktu\xE1lnos\u0165 inform\xE1ci\xED"
        }), " \u2013 presnos\u0165, relevantnos\u0165 a prepojenie s legislat\xEDvou a praxou,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "metodika a didaktika"
        }), " \u2013 \u0161trukt\xFAra \u0161kolenia, jasnos\u0165 prezent\xE1cie, aktiviz\xE1cia \xFA\u010Dastn\xEDkov, vyu\u017Eitie modern\xFDch met\xF3d,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "komunika\u010Dn\xE9 schopnosti"
        }), " \u2013 schopnos\u0165 motivova\u0165, facilitova\u0165 diskusiu, reagova\u0165 na ot\xE1zky, adapt\xE1cia \u0161t\xFDlu komunik\xE1cie,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "pr\xEDprava a profesionalita"
        }), " \u2013 kvalita materi\xE1lov, \u010Dasov\xE1 pr\xEDprava, dodr\u017Eiavanie \u0161tandardov,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "sp\xE4tn\xE1 v\xE4zba \xFA\u010Dastn\xEDkov"
        }), " \u2013 celkov\xE9 hodnotenie spokojnosti, odpor\xFA\u010Danie \u0161kolenia."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.4 N\xE1stroje a proces hodnotenia"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m hodnotenia vyu\u017E\xEDva kombin\xE1ciu n\xE1strojov:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "online formul\xE1re pre sp\xE4tn\xFA v\xE4zbu \xFA\u010Dastn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pravideln\xE9 hodnotiace stretnutia a rozhovory s lektormi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "digit\xE1lne sledovanie v\xFDkonnosti lektorov (pr\xEDprava, realiz\xE1cia, hodnotenie kurzov),"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "individu\xE1lne rozvojov\xE9 pl\xE1ny na z\xE1klade v\xFDsledkov hodnotenia."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "5.5 V\xFDhody syst\xE9mu hodnotenia"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Denie vysokej kvality vzdel\xE1vac\xEDch aktiv\xEDt,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "identifik\xE1cia profesijn\xFDch rozvojov\xFDch potrieb lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "motiv\xE1cia lektorov k neust\xE1lemu zlep\u0161ovaniu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "transparentnos\u0165 a objekt\xEDvnos\u0165 v r\xE1mci organiz\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "prepojenie hodnotenia s pl\xE1nom \u010Fal\u0161ieho vzdel\xE1vania a odborn\xE9ho rozvoja,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zvy\u0161ovanie spokojnosti \xFA\u010Dastn\xEDkov \u0161kolen\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "\xA0"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "6. MOTIV\xC1CIA, PODPORA A BENEFITY PRE LEKTOROV"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Motiv\xE1cia lektorov je k\u013E\xFA\u010Dov\xFDm prvkom pre udr\u017Eanie vysokej kvality vzdel\xE1vac\xEDch aktiv\xEDt. Efekt\xEDvny syst\xE9m motiv\xE1cie nie je len finan\u010Dn\xE9ho charakteru, ale zah\u0155\u0148a aj podporu profesijn\xE9ho rastu, pr\xEDstup k odborn\xFDm zdrojom, mo\u017Enos\u0165 particip\xE1cie na v\xFDznamn\xFDch podujatiach a vytv\xE1ranie prostredia, ktor\xE9 podporuje spolupr\xE1cu a inov\xE1cie."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Cie\u013Eom tejto kapitoly je prezentova\u0165 syst\xE9m podpory a motiv\xE1cie lektorov platformy Profivzdel\xE1vanie.sk, jeho \u0161trukt\xFAru a n\xE1stroje, ktor\xE9 zabezpe\u010Duj\xFA ich profesion\xE1lnu spokojnos\u0165, anga\u017Eovanos\u0165 a kontinu\xE1lny rozvoj."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "6.1 Princ\xEDpy motiv\xE1cie a podpory"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m motiv\xE1cie sa riadi t\xFDmito z\xE1kladn\xFDmi princ\xEDpmi:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "komplexnos\u0165"
        }), " \u2013 motiv\xE1cia zah\u0155\u0148a odborn\xFD, metodick\xFD, osobnostn\xFD a finan\u010Dn\xFD rozmer,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "individualiz\xE1cia"
        }), " \u2013 aktivity a benefity s\xFA prisp\xF4soben\xE9 potreb\xE1m jednotliv\xFDch lektorov,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "transparentnos\u0165"
        }), " \u2013 jasne definovan\xE9 pravidl\xE1 a krit\xE9ri\xE1 pre poskytovanie podpory,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "partnerstvo"
        }), " \u2013 lektori s\xFA vn\xEDman\xED ako strategick\xED partneri, nielen ako poskytovatelia slu\u017Eieb,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "podpora profesijn\xE9ho rastu"
        }), " \u2013 motiv\xE1cia je pevne previazan\xE1 s pr\xEDle\u017Eitos\u0165ami pre odborn\xFD a metodick\xFD rozvoj."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "6.2 Odborn\xE1 podpora a rozvoj"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Platforma poskytuje lektorom systematick\xFA podporu vo forme odborn\xE9ho rastu:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "\xFA\u010Das\u0165 na \u0161koleniach a webin\xE1roch"
        }), " \u2013 mo\u017Enos\u0165 sledova\u0165 intern\xE9 a extern\xE9 vzdel\xE1vacie aktivity,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "certifikovan\xE9 programy"
        }), " \u2013 mo\u017Enos\u0165 absolvova\u0165 odborn\xE9 a legislat\xEDvne kurzy bezplatne,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "pr\xEDstup k produktom Poradcu podnikate\u013Ea"
        }), " \u2013 odborn\xE9 publik\xE1cie, legislat\xEDvne port\xE1ly, n\xE1stroje a videoarch\xEDvy,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "intern\xE9 konzult\xE1cie"
        }), " \u2013 metodick\xE1 podpora pri pr\xEDprave obsahu \u0161kolen\xED a prezent\xE1ci\xED,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "priebe\u017En\xE1 sp\xE4tn\xE1 v\xE4zba"
        }), " \u2013 hodnotenie a odpor\xFA\u010Dania na zlep\u0161enie pedagogickej a odbornej kvality."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "6.3 Finan\u010Dn\xE9 a nefinan\u010Dn\xE9 benefity"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Motiv\xE1cia zah\u0155\u0148a aj tradi\u010Dn\xE9 aj modern\xE9 formy odmien:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "finan\u010Dn\xE9 ohodnotenie"
        }), " \u2013 spravodliv\xE9 honor\xE1re pod\u013Ea typu \u0161kolenia a odbornej n\xE1ro\u010Dnosti,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "benefity nefinan\u010Dn\xE9ho charakteru"
        }), " \u2013 vo forme pr\xEDstupu k odborn\xFDm zdrojom, bezplatn\xE9ho vzdel\xE1vania a \xFA\u010Dasti na konferenci\xE1ch,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "flexibilita"
        }), " \u2013 mo\u017Enos\u0165 prisp\xF4sobi\u0165 si pracovn\xFD \u010Das a formu spolupr\xE1ce,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "uznanie a ocenenie"
        }), " \u2013 verejn\xE9 po\u010Fakovanie, intern\xE9 ocenenia za pr\xEDnos a kvalitu,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "podpora kari\xE9rneho rastu"
        }), " \u2013 pr\xEDle\u017Eitosti vies\u0165 odborn\xE9 projekty, predn\xE1\u0161a\u0165 na konferenci\xE1ch a z\xFA\u010Dast\u0148ova\u0165 sa na inova\u010Dn\xFDch iniciat\xEDvach."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "6.4 Podpora spolupr\xE1ce a t\xEDmov\xE9ho ducha"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Okrem individu\xE1lnej motiv\xE1cie je k\u013E\xFA\u010Dov\xE1 aj podpora t\xEDmov\xE9ho prostredia:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "mentoring a kou\u010Ding"
        }), " \u2013 sk\xFAsen\xED lektori poskytuj\xFA podporu nov\xFDm kolegom,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "intern\xE9 workshopy a brainstormingy"
        }), " \u2013 priestor na zdie\u013Eanie sk\xFAsenost\xED a odborn\xFDch poznatkov,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "spolo\u010Dn\xE9 hodnotiace stretnutia"
        }), " \u2013 sp\xE4tn\xE1 v\xE4zba a tvorba odpor\xFA\u010Dan\xED pre zlep\u0161enie vzdel\xE1vac\xEDch aktiv\xEDt,"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "podpora inov\xE1ci\xED"
        }), " \u2013 motiv\xE1cia lektorov prin\xE1\u0161a\u0165 nov\xE9 met\xF3dy, n\xE1stroje a form\xE1ty vzdel\xE1vania."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "6.5 V\xFDsledky a pr\xEDnosy syst\xE9mu motiv\xE1cie"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Pr\xEDnosy efekt\xEDvneho motiva\u010Dn\xE9ho syst\xE9mu s\xFA:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zv\xFD\u0161enie odborn\xFDch a pedagogick\xFDch kompetenci\xED lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "udr\u017Eanie kvalitn\xE9ho a stabiln\xE9ho lektorsk\xE9ho t\xEDmu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vy\u0161\u0161ia spokojnos\u0165 \xFA\u010Dastn\xEDkov vzdel\xE1vania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podporenie kreativity a inov\xE1cie vo vzdel\xE1vac\xEDch form\xE1toch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "posilnenie reput\xE1cie platformy ako modern\xE9ho a profesion\xE1lneho vzdel\xE1vacieho subjektu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zefekt\xEDvnenie prepojenia medzi hodnoten\xEDm, rozvojom a odmenou lektorov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "T\xE1to kapitola tak mapuje nielen jednotliv\xE9 motiva\u010Dn\xE9 n\xE1stroje, ale aj strategick\xFD pr\xEDstup platformy k budovaniu anga\u017Eovan\xE9ho, odborn\xE9ho a stabiln\xE9ho lektorsk\xE9ho t\xEDmu."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "\xA0"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "7. ORGANIZA\u010CN\xC9 ZABEZPE\u010CENIE A KOMPETENCIE"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Organiza\u010Dn\xE9 zabezpe\u010Denie predstavuje s\xFAbor procesov, pravidiel a rol\xED, ktor\xE9 umo\u017E\u0148uj\xFA pl\xE1novanie, realiz\xE1ciu, monitorovanie a hodnotenie vzdel\xE1vac\xEDch aktiv\xEDt, a t\xFDm aj udr\u017Eanie vysok\xE9ho \u0161tandardu kvality vzdel\xE1vania na platforme Profivzdel\xE1vanie.sk."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "T\xE1to kapitola sa zameriava na identifik\xE1ciu organiza\u010Dn\xFDch zlo\u017Eiek a kompetenci\xED, ktor\xE9 s\xFA nevyhnutn\xE9 pre podporu lektorov a efekt\xEDvnu realiz\xE1ciu strat\xE9gie rozvoja \u013Eudsk\xFDch zdrojov."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "7.1 Organiza\u010Dn\xE1 \u0161trukt\xFAra zodpovedn\xE1 za rozvoj lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Platforma Profivzdel\xE1vanie.sk vyu\u017E\xEDva kombinovan\xFD model riadenia, kde jednotliv\xE9 \xFArovne spolupracuj\xFA na zabezpe\u010Den\xED koordin\xE1cie, metodickej podpory a strategick\xE9ho pl\xE1novania:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Vedenie \xFAseku Vzdel\xE1vanie"
        }), " \u2013 zodpoved\xE1 za strategick\xE9 riadenie rozvoja lektorov, nastavuje ciele a priority, sleduje dodr\u017Eiavanie \u0161tandardov kvality a zabezpe\u010Duje alok\xE1ciu zdrojov."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Mana\u017Ement vzdel\xE1vania"
        }), " \u2013 poskytuje odborn\xE9 a didaktick\xE9 poradenstvo, pripravuje metodick\xE9 materi\xE1ly, koordinuje intern\xE9 \u0161kolenia a hodnot\xED kvalitu vzdel\xE1vac\xEDch aktiv\xEDt."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Projektov\xED koordin\xE1tori"
        }), " \u2013 zodpovedaj\xFA za logistiku, administr\xE1ciu, harmonogramy \u0161kolen\xED a \xFA\u010Das\u0165 lektorov, komunik\xE1ciu s \xFA\u010Dastn\xEDkmi a zabezpe\u010Denie technick\xFDch a organiza\u010Dn\xFDch podmienok."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "HR oddelenie"
        }), " \u2013 podporuje n\xE1bor a adapt\xE1ciu lektorov, koordinuje motiva\u010Dn\xE9 a hodnotiace procesy, spracov\xE1va benefity a dohliada na dodr\u017Eiavanie intern\xFDch pravidiel."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "7.2 Kompetencie jednotliv\xFDch akt\xE9rov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Pre efekt\xEDvnu realiz\xE1ciu strat\xE9gie s\xFA kompetencie jasne definovan\xE9 pre ka\u017Ed\xFA \xFArove\u0148:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "7.2.1 Vedenie \xFAseku Vzdel\xE1vanie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "stanovuje dlhodob\xFA a kr\xE1tkodob\xFA strat\xE9giu rozvoja lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "ur\u010Duje priority vzdel\xE1vac\xEDch aktiv\xEDt,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Duje zdroje a rozpo\u010Det pre rozvoj lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "koordinuje spolupr\xE1cu medzi intern\xFDmi a extern\xFDmi lektormi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnot\xED v\xFDsledky a efektivitu vzdel\xE1vacieho syst\xE9mu."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "7.2.2 Mana\u017Ement vzdel\xE1vania:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pripravuje obsah vzdel\xE1vac\xEDch aktiv\xEDt, metodick\xE9 pr\xEDru\u010Dky a n\xE1vody,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Duje jednotnos\u0165 kvality vzdel\xE1vac\xEDch programov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "poskytuje lektorom konzult\xE1cie a sp\xE4tn\xFA v\xE4zbu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "monitoruje aktu\xE1lne vzdel\xE1vacie trendy a navrhuje inov\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podporuje systematick\xE9 hodnotenie lektorov a analyzuje jeho v\xFDsledky."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "7.2.3 Projektov\xED koordin\xE1tori:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "koordinuj\xFA logistiku a administr\xE1ciu vzdel\xE1vac\xEDch aktiv\xEDt,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Duj\xFA technick\xFA podporu pre online a prezen\u010Dn\xE9 \u0161kolenia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pripravuj\xFA harmonogramy a \xFA\u010Dastn\xEDcke zoznamy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "monitoruj\xFA dodr\u017Eiavanie term\xEDnov a procesov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "komunikuj\xFA s lektormi oh\u013Eadom organiza\u010Dn\xFDch po\u017Eiadaviek."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "7.2.4 HR oddelenie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "koordinuje n\xE1bor a adapt\xE1ciu nov\xFDch lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "spravuje syst\xE9m motiva\u010Dn\xFDch n\xE1strojov a benefitov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "sleduje dodr\u017Eiavanie intern\xFDch pravidiel a procesov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podporuje hodnotiace a sp\xE4tnov\xE4zbov\xE9 mechanizmy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Duje prepojenie hodnotenia s pl\xE1nom profesijn\xE9ho rozvoja."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "7.3 Procesy organiza\u010Dn\xE9ho zabezpe\u010Denia"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "K\u013E\xFA\u010Dov\xE9 procesy zabezpe\u010Duj\xFA plynul\xFA realiz\xE1ciu rozvoja lektorov:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Pl\xE1novanie a koordin\xE1cia"
        }), " \u2013 ro\u010Dn\xFD pl\xE1n vzdel\xE1vac\xEDch aktiv\xEDt a rozvojov\xFDch projektov, harmonogramy, alok\xE1cia lektorov."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Podpora a superv\xEDzia"
        }), " \u2013 metodick\xE1 a odborn\xE1 podpora, mentoring, konzult\xE1cie."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Hodnotenie a sp\xE4tn\xE1 v\xE4zba"
        }), " \u2013 systematick\xE9 z\xEDskavanie a spracovanie hodnotiacich d\xE1t, prepojenie s rozvojov\xFDmi pl\xE1nmi."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Reporting a monitoring"
        }), " \u2013 sledovanie naplnenia cie\u013Eov, \xFA\u010Dinnosti vzdel\xE1vac\xEDch aktiv\xEDt, identifik\xE1cia zlep\u0161en\xED."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Kontinu\xE1lne zlep\u0161ovanie"
        }), " \u2013 adapt\xE1cia procesov na z\xE1klade sk\xFAsenost\xED a trendov vo vzdel\xE1van\xED, implement\xE1cia inov\xE1ci\xED."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "7.4 Prepojenie organiza\u010Dn\xFDch kompetenci\xED s rozvojom lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Jasn\xE9 vymedzenie kompetenci\xED a organiza\u010Dn\xFDch zodpovednost\xED umo\u017E\u0148uje:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "koordinovan\xFD a efekt\xEDvny rozvoj lektorov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "minimaliz\xE1ciu duplicitn\xFDch procesov a nejasnost\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "prepojenie hodnotenia a vzdel\xE1vania s motiva\u010Dn\xFDmi mechanizmami,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zv\xFD\u0161enie kvality vzdel\xE1vac\xEDch aktiv\xEDt,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "podporu stability a profesionality lektorsk\xE9ho t\xEDmu."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\xA0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "\xA0"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "Z\xC1VER"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Dokument reflektuje potrebu prepojenia odborn\xE9ho rastu, pedagogick\xFDch zru\u010Dnost\xED, osobnostn\xE9ho rozvoja a motiva\u010Dn\xFDch mechanizmov s organiza\u010Dn\xFDmi procesmi, hodnoten\xEDm a dostupn\xFDmi n\xE1strojmi. Cie\u013Eom strat\xE9gie je nielen zabezpe\u010Di\u0165 kontinu\xE1lne zvy\u0161ovanie kvalifik\xE1cie lektorov prostredn\xEDctvom intern\xFDch a extern\xFDch \u0161kolen\xED, certifikovan\xFDch programov, \xFA\u010Dasti na odborn\xFDch konferenci\xE1ch a workshopoch, ale aj podpori\u0165 ich samostatn\xFD odborn\xFD rozvoj a pr\xEDstup k v\u0161etk\xFDm relevantn\xFDm produktom platformy, ktor\xE9 s\xFA k dispoz\xEDcii bezplatne."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Syst\xE9m hodnotenia je integr\xE1lnou s\xFA\u010Das\u0165ou strat\xE9gie, pri\u010Dom poskytuje objekt\xEDvnu a transparentn\xFA sp\xE4tn\xFA v\xE4zbu \xFA\u010Dastn\xEDkov, intern\xE9ho mana\u017E\xE9rskeho t\xEDmu a samotn\xFDch lektorov. Tento proces umo\u017E\u0148uje identifikova\u0165 siln\xE9 str\xE1nky, odhali\u0165 oblasti na zlep\u0161enie a prepoji\u0165 hodnotenie s pl\xE1novan\xFDm profesion\xE1lnym rastom ka\u017Ed\xE9ho lektora. S\xFA\u010Dasne strat\xE9gia podporuje motiv\xE1ciu a anga\u017Eovanos\u0165 lektorov prostredn\xEDctvom kombin\xE1cie finan\u010Dn\xFDch a nefinan\u010Dn\xFDch benefitov, partnersk\xE9ho pr\xEDstupu a jasne definovan\xFDch pravidiel. Vytv\xE1ra prostredie, kde lektori maj\xFA mo\u017Enos\u0165 participova\u0165 na tvorbe obsahu \u0161kolen\xED, vyu\u017E\xEDva\u0165 modern\xE9 metodiky a akt\xEDvne prispieva\u0165 k inov\xE1ci\xE1m vo vzdel\xE1van\xED."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Organiza\u010Dn\xE9 zabezpe\u010Denie strat\xE9gie je rie\u0161en\xE9 jasne definovan\xFDmi kompetenciami jednotliv\xFDch akt\xE9rov vr\xE1tane vedenia \xFAseku Vzdel\xE1vanie, mana\u017E\xE9rskeho t\xEDmu, projektov\xFDch koordin\xE1torov, HR oddelenia. Ka\u017Ed\xE1 \xFArove\u0148 m\xE1 presne stanoven\xE9 zodpovednosti v oblasti pl\xE1novania, realiz\xE1cie, hodnotenia a podpory lektorov, \u010Do umo\u017E\u0148uje koordinovan\xFA a efekt\xEDvnu implement\xE1ciu rozvojov\xFDch aktiv\xEDt. Strategick\xFD v\xFDznam tejto strat\xE9gie spo\u010D\xEDva v posilnen\xED stability a kvality lektorsk\xE9ho t\xEDmu, zvy\u0161ovan\xED spokojnosti \xFA\u010Dastn\xEDkov vzdel\xE1vania, reagovan\xED na aktu\xE1lne trendy a legislat\xEDvne zmeny a zabezpe\u010Den\xED dlhodobej odbornosti a profesionality platformy."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Cel\xFD syst\xE9m vytv\xE1ra udr\u017Eate\u013En\xFD r\xE1mec, ktor\xFD prep\xE1ja hodnotenie, vzdel\xE1vanie a motiva\u010Dn\xE9 mechanizmy do jednotn\xE9ho procesu. Strat\xE9gia tak poskytuje nielen s\xFAhrn existuj\xFAcich aktiv\xEDt, ale predstavuje aj n\xE1stroj pre \u010Fal\u0161\xED rozvoj, inov\xE1cie a zabezpe\u010Denie vysok\xE9ho \u0161tandardu kvality vzdel\xE1vania. Platforma Profivzdel\xE1vanie.sk prostredn\xEDctvom tejto strat\xE9gie jasne deklaruje svoju orient\xE1ciu na podporu lektorov, ich odborn\xFD rast a profesion\xE1lnu spokojnos\u0165, \u010D\xEDm posil\u0148uje svoju poz\xEDciu ako modern\xE9ho a d\xF4veryhodn\xE9ho vzdel\xE1vacieho subjektu."
    })]
  });
};

/* harmony default export */ var TeacherTeamDevelopmentStrategy_TeacherTeamDevelopmentStrategy = (TeacherTeamDevelopmentStrategyTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
;// CONCATENATED MODULE: ./src/pages/strategia-rozvoja-lektorov-a-timu.tsx










var TeacherTeamDevelopmentStrategy = function TeacherTeamDevelopmentStrategy() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TeacherTeamDevelopmentStrategy_TeacherTeamDevelopmentStrategy, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var strategia_rozvoja_lektorov_a_timu = (TeacherTeamDevelopmentStrategy);

/***/ }),

/***/ 42394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategia-rozvoja-lektorov-a-timu",
      function () {
        return __webpack_require__(80167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77191:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectDestructuringEmpty; }
/* harmony export */ });
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

/***/ }),

/***/ 90116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(28811);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4623,9774,2888,179], function() { return __webpack_exec__(42394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);